import api from './index'

export default function getRecaptchaKey() {
  return api.get(`/api/recaptcha/key`)
}
